// frontend/src/api/fileComment.js
// Funciones API para la gestión de archivos y comentarios del proyecto.
// AHORA USA el manejador de peticiones de archivo centralizado.

import { request, fileRequest } from './api';

/**
 * @function uploadFile
 * @description Sube un archivo a un proyecto específico.
 * @param {string} projectId - ID del proyecto.
 * @param {FormData} formData - Objeto FormData que contiene el archivo y datos adicionales.
 * @param {string} token - Token JWT de autorización.
 * @returns {Promise<object>} - El registro del archivo creado.
 */
export async function uploadFile(projectId, formData, token) {
  // Ahora usamos la función 'fileRequest' centralizada que maneja el error 401.
  return fileRequest(`/api/projects/${projectId}/files`, formData, token);
}

/**
 * @function addComment
 * @description Añade un comentario a un proyecto.
 * @param {string} projectId - ID del proyecto.
 * @param {string} text - Contenido del comentario.
 * @param {string} token - Token JWT de autorización.
 * @returns {Promise<object>} - El comentario creado.
 */
export async function addComment(projectId, text, token) {
  return request(`/api/projects/${projectId}/comments`, 'POST', { text }, token);
}

/**
 * @function deleteFile
 * @description Elimina un archivo por su ID.
 * @param {string} fileId - ID del archivo.
 * @param {string} token - Token JWT de autorización.
 * @returns {Promise<object>} - Respuesta vacía si tiene éxito.
 */
export async function deleteFile(fileId, token) {
  return request(`/api/files/${fileId}`, 'DELETE', null, token);
}
